/**
 * Created by frank.law on 11/16/17.
 */
import React from 'react';
import '../../../css/login.css';
import {connect} from 'react-redux';
import UsernameField from '../formFields/UsernameField';
import FieldError from '../formFields/FieldError';
import {LocalForm} from 'react-redux-form';
import {resetForms, submitUsernameChallenge, usernameOnChange} from '../../actions/actions';
import PropTypes from 'prop-types';
import LoginUtils from '../../utils/LoginUtils';

class UsernameForm extends React.Component {

    componentDidMount() {
        const {resetForms, usernameOnChange, username} = this.props;
        resetForms();
        usernameOnChange(username);
    }

    handleSubmit(formValues) {
        const { submitUsernameForm, token, challenge} = this.props;
        submitUsernameForm(formValues.username, token, challenge);
    }

    render() {
        const {usernameError, usernameOnChange, usernameFieldValue, usernameLabel, usernamePlaceholder, submitLabel, challenge} = this.props;

        let errorField = [];
        if (usernameError) {
            errorField = (<FieldError errorText={usernameError}/>);
        }

        return (
            <div key="UsernameForm_1">
                <LocalForm role="form" model="loginForm" className="login-form" onSubmit={(formValues) => this.handleSubmit(formValues)}>
                    <UsernameField onChangeFunc={usernameOnChange} defaultValue={usernameFieldValue} label={usernameLabel} placeholder={usernamePlaceholder} isError={(usernameError && usernameError.length > 0)}/>
                    {errorField}
                    <button className="wdc-btn wdc-btn-primary" disabled={!LoginUtils.checkUsernameValidity(usernameFieldValue, challenge)}>{submitLabel}</button>
                </LocalForm>
            </div>
        );
    }
}

UsernameForm.propTypes = {
    usernameError: PropTypes.string,
    usernameOnChange: PropTypes.func,
    usernameFieldValue: PropTypes.string,
    usernameLabel: PropTypes.string,
    usernamePlaceholder: PropTypes.string,
    submitLabel: PropTypes.string,
    submitUsernameForm: PropTypes.func,
    token: PropTypes.string,
    challenge: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        username: state.login.username,
        usernameError: state.login.errorText,
        usernameFieldValue: state.forms.username,
        token: state.login.token,
        challenge: state.login.challengeResponse.nextChallenge,
        usernameLabel: state.login.challengeResponse.prompts.inputPrompt.label,
        usernamePlaceholder: state.login.challengeResponse.prompts.inputPrompt.placeholder,
        submitLabel: state.login.challengeResponse.submitLabel,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetForms: () => {
          dispatch(resetForms());
        },
        usernameOnChange: (newValue) => {
            dispatch(usernameOnChange(newValue))
        },
        submitUsernameForm: (newValue, token, challenge) => {
            dispatch(submitUsernameChallenge(newValue, token, challenge));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UsernameForm);
